import { useApi } from '../hooks/useApi.js';
import { fetchStats } from '../lib/api.js';
import { Seo } from '../components/Seo.jsx';
import { PageHeader } from '../components/PageHeader.jsx';
import { Prose } from '../components/Prose.jsx';
import { StatsBar } from '../components/StatsBar.jsx';
import { SectionHead } from '../components/SectionHead.jsx';
import { usePage } from '../hooks/usePage.js';

export function AboutPage() {
  const page = usePage('about');
  const { data: stats } = useApi(fetchStats, []);

  return (
    <>
      <Seo
        title="About Us"
        description={page.metaDescription}
      />

      <PageHeader
        crumbs={[{ label: 'Home', to: '/' }, { label: 'About Us' }]}
        headline={page.headline}
        lede={page.lede}
        image={page.banner}
      />

      <section>
        <div className="container">
          {page.body ? (
            <Prose html={page.body} />
          ) : (
            <Prose>
              <p className="lede">Maple Leaf International School is one of the most prestigious English Medium schools in Bangladesh. Since 1972, we have followed the British Curriculum, leading our students to IGCSE, GCE 'A' Levels and International Advanced Level qualifications.</p>
              <p>The school provides an invigorating and competitive atmosphere, created by excellent facilities and the guidance of a highly qualified and dedicated faculty. Our learners are at the heart of everything we do.</p>
              <h2>Our mission</h2>
              <p>To nurture confident, curious and compassionate young people — equipped with the academic foundation, character and global outlook needed to flourish at the world's best universities and beyond.</p>
              <blockquote>Each of our students may take different routes on their educational journey, but our aim remains constant for all — to enlighten the path ahead.</blockquote>
              <h2>What we stand for</h2>
              <ul>
                <li><strong>Quality &amp; integrity</strong> — Registered with the Bangladesh Education Ministry, Edexcel and CAIE.</li>
                <li><strong>Outstanding academic record</strong> — A 98% university placement rate, both nationally and internationally.</li>
                <li><strong>Learner-focused curriculum</strong> — A wide spectrum of subjects with yearly assessment and rigorous co-curricular activities.</li>
                <li><strong>Trained, experienced faculty</strong> — Modern resource materials, laboratories and academic counselling.</li>
              </ul>
            </Prose>
          )}
        </div>
      </section>

      {/* By the numbers — borderless StatsBar in a cream section */}
      <section className="bg-cream">
        <div className="container">
          <SectionHead align="center" eyebrow="By the numbers" rawTitle="Our <em>impact</em>" />
          <div style={{ marginTop: 32 }}>
            <StatsBar stats={stats} />
          </div>
        </div>
      </section>
    </>
  );
}
